// extracted by mini-css-extract-plugin
export var bgWrapper = "style-module--bgWrapper--20kSP";
export var container = "style-module--container--PxPOR";
export var divider = "style-module--divider--Du415";
export var dotsWrapper2 = "style-module--dotsWrapper2--IvAvg";
export var header = "style-module--header--dojyK";
export var highlight = "style-module--highlight--OpkkL";
export var img = "style-module--img--XREGu";
export var imgWrapper = "style-module--imgWrapper--PviKu";
export var line = "style-module--line--nyiOY";
export var otherProjects = "style-module--otherProjects--TQdoO";
export var otherWrapper = "style-module--otherWrapper--LwUWb";
export var others = "style-module--others--wL-DY";
export var partnersTitle = "style-module--partnersTitle--5mFtz";
export var place = "style-module--place--KUja7";
export var project = "style-module--project--fViq4";
export var projectTitle = "style-module--projectTitle--RqP7b";
export var root = "style-module--root--FQQhW";
export var summaryText = "style-module--summaryText--YdBEK";
export var text = "style-module--text--vJR+i";
export var title = "style-module--title--egkV0";
export var winners = "style-module--winners--CGkqq";
export var winnersImg = "style-module--winnersImg--ACelZ";
export var winnersTitle = "style-module--winnersTitle---SKGL";